export const Logo = ({ className = "" }) => (
  <span className={`font-display font-black tracking-tight ${className}`} data-testid="app-logo">
    Stream<span className="text-primary">Pick</span>
    <span className="text-muted-foreground font-bold">.net</span>
  </span>
);

export const TmdbAttribution = ({ compact = false }) => (
  <div data-testid="tmdb-attribution-badge" className="flex items-center gap-3 text-xs text-muted-foreground">
    <img
      src="https://www.themoviedb.org/assets/2/v4/logos/v2/blue_short-8e7b30f73a4020692ccca9c88bafe5dcb6f8a62a4c6bc55cd9ba82bb2cd95f6c.svg"
      alt="TMDB"
      className={compact ? "h-2.5" : "h-3"}
    />
    <span>This product uses the TMDB API but is not endorsed or certified by TMDB.</span>
  </div>
);
